import { getExtension } from '../utils/file/extension-utils';
import { PageData } from '../types/route-types';

export interface ValidationResult {
    accepted: File[];
    rejected: RejectedFile[];
}

export interface RejectedFile {
    file: File;
    extension: string;
    reason: string;
    suggestedPages: SuggestedPage[];
    /**
     * Where the suggestion lookup got to. Without this, "no suggestions yet" and "the lookup
     * failed" are the same empty array, and the UI shows "Finding the right tool..." forever --
     * a spinner that never resolves reads as a broken page.
     */
    suggestionStatus?: 'loading' | 'loaded' | 'failed';
}

export interface SuggestedPage {
    url: string;
    title: string;
    category: string;
}

export class FileValidationService {

    validate(files: File[], pageData: PageData): ValidationResult {
        const acceptedExts = pageData.acceptedExtensions || [];

        if (acceptedExts.length === 0) {
            return { accepted: Array.from(files), rejected: [] };
        }

        const accepted: File[] = [];
        const rejected: RejectedFile[] = [];

        for (const file of files) {
            const ext = getExtension(file.name).toLowerCase();
            if (acceptedExts.includes(ext)) {
                accepted.push(file);
            } else {
                rejected.push({
                    file,
                    extension: ext,
                    reason: `".${ext}" files are not supported here`,
                    suggestedPages: [],
                });
            }
        }

        return { accepted, rejected };
    }
}
